import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import ButtonNew from "components/buttonNew/buttonNew";
import { useEffect, useState } from "react";
import { Calendar, Money } from "@phosphor-icons/react";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { useSession } from "@clerk/clerk-react";

interface SetFuturePriceModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: any;
  onSuccess: () => void;
}

export const SetFuturePriceModal = ({ isOpen, onClose, product, onSuccess }: SetFuturePriceModalProps) => {
  const [basePrice, setBasePrice] = useState("");
  const [indexedPrice, setIndexedPrice] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");
  const { session } = useSession();

  useEffect(() => {
    if (product && product.price && product.price.length > 0) {
      const sortedPrices = [...product.price].sort(
        (a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime()
      );

      const today = new Date();
      const currentPrices = sortedPrices.filter(p => new Date(p.effectiveDate) <= today);

      const currentBasePrice = currentPrices.find(p => p.changeMetaData === 'INIT');
      const currentIndexedPrice = currentPrices.find(p => p.changeMetaData === 'ACTUAL_AT_CREATION');

      console.log("Current base price:", currentBasePrice);
      console.log("Current indexed price:", currentIndexedPrice);

      if (currentBasePrice) {
        setBasePrice(currentBasePrice.amount.toString());
      }
      if (currentIndexedPrice) {
        setIndexedPrice(currentIndexedPrice.amount.toString());
      }
      
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      nextMonth.setDate(1);
      setEffectiveDate(nextMonth.toISOString().split('T')[0]);
    }
  }, [product, isOpen]);

  const handleSubmit = async () => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/rental/products/${product.id}/set-future-price`,
        {
          method: "POST",
          body: JSON.stringify({
            basePrice: parseFloat(basePrice),
            indexedPrice: parseFloat(indexedPrice),
            effectiveDate
          }),
          headers: { "Content-Type": "application/json" },
        },
        session
      );

      if (response.ok) {
        toast.success("Toekomstige prijs succesvol ingesteld");
        onSuccess();
        onClose();
        
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('refreshContracts'));
        }
      } else {
        toast.error("Er ging iets mis bij het instellen van de toekomstige prijs");
      }
    } catch (error) {
      toast.error("Netwerk- of serverfout");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Calendar weight="duotone" size={24} />
            <h3 className="text-lg font-medium">Stel toekomstige prijs in</h3>
          </div>
          <p className="text-sm text-neutral-secondary">
            Product: {product?.name}
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium">Basishuur</label>
              <div className="flex items-center gap-2">
                <Money weight="duotone" size={20} className="text-neutral-secondary" />
                <input
                  type="number"
                  value={basePrice}
                  onChange={(e) => setBasePrice(e.target.value)}
                  className="w-full rounded-lg border border-neutral-primary/20 p-2"
                  placeholder="0.00"
                  step="0.01"
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium">Geïndexeerde huur</label>
              <div className="flex items-center gap-2">
                <Money weight="duotone" size={20} className="text-neutral-secondary" />
                <input
                  type="number"
                  value={indexedPrice}
                  onChange={(e) => setIndexedPrice(e.target.value)}
                  className="w-full rounded-lg border border-neutral-primary/20 p-2"
                  placeholder="0.00"
                  step="0.01"
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium">Ingangsdatum</label>
              <div className="flex items-center gap-2">
                <Calendar weight="duotone" size={20} className="text-neutral-secondary" />
                <input
                  type="date"
                  value={effectiveDate}
                  onChange={(e) => setEffectiveDate(e.target.value)}
                  className="w-full rounded-lg border border-neutral-primary/20 p-2"
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonNew
            variant="primaryMoss"
            onClick={handleSubmit}
            label="Bevestigen"
          />
          <ButtonNew
            variant="secondaryNeutral"
            onClick={onClose}
            label="Annuleren"
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 